import { render, staticRenderFns } from "./userCreateForm.vue?vue&type=template&id=8b46cb0e&scoped=true&"
import script from "./userCreateForm.vue?vue&type=script&lang=js&"
export * from "./userCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./userCreateForm.vue?vue&type=style&index=0&id=8b46cb0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b46cb0e",
  null
  
)

export default component.exports